import * as constants from '../constants';

const INITIAL_STATE = {
    current: null,
    error: null,
    loading: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.ORGANIZATION_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null, current: null});
        case constants.ORGANIZATION_SUCCESS:
            return Object.assign({}, state, {loading: false, error: null, current: action.payload.item});
        case constants.ORGANIZATION_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});
        case constants.ORGANIZATION_EDIT_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
    }
    return state;
}
